import { IEquipment, IEquipmentEvent } from '@/pages/Equipment/equipment.types'

const computeIsCarInMotion = (MDRunSgl: number, carSpeedWhole: number, carSpeedFractional: number) => {
  const isCarSpeedPositive = carSpeedWhole > 0 || (carSpeedWhole === 0 && carSpeedFractional > 0)
  return Number(MDRunSgl === 1 && isCarSpeedPositive)
}

const computedIsKMF34Closed = (MDReadySgl: number, ONKMCSgl: number, MDRunSgl: number, K7RelayState: number) =>
  Number(MDReadySgl && ONKMCSgl && (K7RelayState || MDRunSgl))

const computedIsKMF12Closed = (MDReadySgl: number, MDRunSgl: number, K7RelayState: number) =>
  Number(MDReadySgl && (K7RelayState || MDRunSgl))

const isKMFContactorBreak = (MDRunSgl: number, MDReadySgl: number, ONKMCSgl: number, K7RelayState: number) =>
  computedIsKMF34Closed(MDReadySgl, ONKMCSgl, MDRunSgl, K7RelayState) === 1 &&
  computedIsKMF12Closed(MDReadySgl, MDRunSgl, K7RelayState) === 1 &&
  !MDRunSgl &&
  !K7RelayState

const isKMFContactorWelded = (equipment: IEquipment, events: IEquipmentEvent[]) =>
  equipment?.errorCode === '131' || events.findIndex((ev) => ev.payload.errorCode === '131') !== -1

const liftWinchPowerComputeFunctions = {
  computeIsCarInMotion,
  isKMFContactorBreak,
  computedIsKMF34Closed,
  isKMFContactorWelded,
  computedIsKMF12Closed,
}

export default liftWinchPowerComputeFunctions
